import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'user-feedback',
    styles: [ require('./user-feedback.component.scss') ],
    template: require('./user-feedback.component.pug'),
})
export class UserFeedbackComponent implements OnInit {
    @Input() type = 'info'; // values: info, warning, error, success
    @Input() message: string;

    icon = 'info';

    ngOnInit() {
        switch (this.type) {
            case 'info':
                this.icon = 'info-outline';
                break;
            case 'warning':
                this.icon = 'alert-triangle';
                break;
            case 'success':
                this.icon = 'check';
                break;
            case 'error':
                this.icon = 'alert-octagon';
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/ui/user-feedback/user-feedback.component.ts